<template>
<div class="container-fluid">

	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
		<template v-if="assets.length">
		    <div class="col-12">
			    <div class="d-flex align-items-center">
			    	<h1 class="flex-grow-1 mr-2" data-test="pageTitle">All Media Assets</h1>
					<span
						v-if="perms.can_create_asset"
						v-tooltip.bottom="'Add Asset'"
						class="btn btn-sm btn-ghost-primary text-gray-500 cursor-pointer leading-none"
						data-toggle="modal" data-target="#assetCreateModal">
						<i class="far fa-plus-circle text-xl"></i>
					</span>
			    </div>
			</div>

			<div class="col-12">	
			    <div class="card-deck">
			    	<asset-item
			    		v-for="(asset, key) in assets"
			    		:key="key"
			    		:asset="asset"
			    		:asset_types="asset_types"
			    		@view_details="showAsset($event)"
			    		@asset_updated="updateAsset($event)"
			    		@delete_asset="deleteAsset($event)"
			    	/>
			    </div>
			</div>
		</template>

		<div v-else class="col-12 text-center">
			<div class="mx-auto rounded-circle circle-cropped avatar-xl bg-secondary text-white text-5xl mb-4 mt-5">
	    		<i class="fad fa-image fa-fw"></i>
	    	</div>
	    	<div class="font-weight-bold text-2xl text-gray-700">
	    		Add your first media asset
	    	</div>
	    	<div class="font-lg text-gray-500 mb-3">
	    		Track materials and information you've left on check-ins
	    	</div>
	    	<span class="btn btn-primary btn-lg" data-toggle="modal" data-target="#assetCreateModal">Create Asset</span>
	    </div>
	</div>



	<asset-create-modal 
		:asset_types="asset_types"
		@asset_added="addAsset($event)"
	/>

	<asset-view-modal
		:asset_id="show_id"
	/>

</div>
</template>

<script>
	import { mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	import AssetCreateModal from '../../components/AssetCreateModal';
	import AssetItem from '../../components/AssetItem';
	import AssetViewModal from '../../components/AssetViewModal';

	export default {
    	mixins: [BreadcrumbsManager],

		components: {
			AssetCreateModal,
			AssetItem,
			AssetViewModal,
		},

        data() {
            return {
                assets: null,
                asset_types: [],
                data_loaded: false,
                show_id:null,
            }
        },

        created() {
        	this.fetchAssets();        	
			this.fetchAssetTypes(); 			
        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Media Asssets', to: { name: 'assets.index' } },
            ]);  
        },

        methods: {
        	addAsset($event) {
        		this.assets.push($event);
        	},

        	fetchAssets() {
        		axios.get('/api/assets').then(({data}) => {
                    this.assets = data;
                    this.data_loaded = true;
	        	});
        	},

			fetchAssetTypes() {
	            axios.get(`/api/asset-types`).then(({data}) => {
	                this.asset_types = data;
	        	});	 
			},

            deleteAsset(id) {
                Swal.fire({
					title: 'Are you sure?',
					text: 'You will not be able to recover this asset!',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Delete asset',
					cancelButtonText: 'Keep asset',
					animation: false,
                    }).then((result) => {
                        if (result.value) {
                            axios.delete(`/api/assets/${id}`, id).then(() => {
                                let index = this.assets.findIndex(x => x.id === id);
                            	this.assets.splice(index, 1);
                            	this.$store.dispatch('refreshAssets');
                            })
                        }
                    }
                );
            },

            showAsset($event) {
            	this.show_id = $event;
            },

            updateAsset($event) {
            	console.log($event);
            	let index = this.assets.findIndex(x => x.id === $event.id);
            	this.assets[index] = $event;

					this.$forceUpdate();
            }
        },

        computed: mapState(['perms'])
    }
</script>

<style>
	.asset:hover .drop-down {
		box-shadow: inset 0px 40px 25px -25px rgba(0,0,0,.45);
		transition: .15s ease-in all;
	}
	.asset .drop-down {
		position:absolute;
		height:50px;
		transition: .15s ease-in all;
	}
</style>